import { render } from "./Biometrics.vue?vue&type=template&id=6a85d3fa&scoped=true"
import script from "./Biometrics.vue?vue&type=script&lang=js"
export * from "./Biometrics.vue?vue&type=script&lang=js"

import "./Biometrics.vue?vue&type=style&index=0&id=6a85d3fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_4cebc095a9b5bcc882fa23a41973ce86/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a85d3fa"]])

export default __exports__